<template>
  <div>
    <section>
      <v-parallax src="/images/price_top.jpeg" height="460">
        <v-row align-content="center" class="position-relative">
          <v-row class="text-center mt-15 mt-sm-10 mb-5 mb-sm-12 full-width">
            <v-col class="pa-1">
              <h1 class="text-xs-center pretopia-head-font pretopia-display-3 white--text text-shadow">
                30% på alla abonnemang!
              </h1>
              <h2 class="text-center py-3 white--text text-shadow">För dig som besökte oss på Formex</h2>
            </v-col>
          </v-row>
        </v-row>
      </v-parallax>
    </section>

    <v-container style="margin-top: -140px">
      <v-row>
        <v-col md="6" lg="6" offset-md="3" offset-lg="3">
          <v-card>
            <v-card-title class="headline">Skapa leverantörskonto</v-card-title>

            <v-card-text>
              <p class="text-body-1">
                Kul att ni vill använda våra tjänster!<br />
                Fyll i uppgifterna här under så kontaktar vi er så snart som möjligt när kontot har skapats.
              </p>

              <v-form v-model="companyValid" v-if="!showSuccess">
                <v-text-field
                  v-model="model.company.name"
                  :rules="requiredRules"
                  required
                  label="Företagsnamn *"
                ></v-text-field>
                <v-text-field v-model="model.company.organizationNumber" label="Organisationsnummer"></v-text-field>
                <v-text-field
                  v-model="model.company.contactName"
                  :rules="requiredRules"
                  required
                  label="Kontaktperson *"
                ></v-text-field>
                <v-text-field
                  v-model="model.company.emailPhone"
                  :rules="requiredRules"
                  required
                  label="Telefon eller Epost *"
                ></v-text-field>

                <p class="mt-3 mb-2 text-body-1">Abonnemang:</p>
                <v-radio-group v-model="model.company.subscription" column class="mt-0 mb-3">
                  <v-radio value="basic">
                    <template v-slot:label>
                      <div><b>Basic</b> - Nå landets viktigaste redaktioner och frilansare</div>
                    </template>
                  </v-radio>
                  <v-radio value="standard">
                    <template v-slot:label>
                      <div><b>Standard</b> - För dig som vill ha ut mer av ditt medlemsskap hos oss</div>
                    </template>
                  </v-radio>
                  <v-radio value="premium">
                    <template v-slot:label>
                      <div><b>Premium</b> - För dig som vill synas ännu mer</div>
                    </template>
                  </v-radio>
                  <v-radio value="premium_plus">
                    <template v-slot:label>
                      <div><b>Premium +</b> - För dig som vill ha lite mer av allt...</div>
                    </template>
                  </v-radio>
                  <v-radio value="grande">
                    <template v-slot:label>
                      <div><b>Grande</b> - Maximera ditt genomslag i alla kanaler</div>
                    </template>
                  </v-radio>
                </v-radio-group>

                <p class="mb-0 text-body-1">Pris: {{ discountPriceYear }} kr/år *</p>
                <!-- <v-radio-group v-model="model.company.subscriptionInterval" column class="mt-0">
                  <v-radio value="month" class="mb-0">
                    <template v-slot:label> -->
                      <!-- <div><b>Per månad:</b> {{ discountPriceMonth }} kr/mån *</div> -->
                    <!-- </template>
                  </v-radio>
                  <p class="font-italic text-caption ml-8 mb-2 grey--text">Ord: {{ ordinariePriceMonth }} kr/mån</p>
                  <v-radio value="year" class="mb-0">
                    <template v-slot:label> -->
                      <!-- <div><b>Per år:</b> {{ discountPriceYear }} kr/år *</div> -->
                    <!-- </template>
                  </v-radio> -->
                  <p class="font-italic text-caption grey--text">Ordinarie pris: {{ ordinariePriceYear }} kr/år</p>
                <!-- </v-radio-group> -->

                <v-textarea v-model="model.company.message" label="Meddelande" class="pt-0"></v-textarea>
              </v-form>

              <v-alert type="success" text outlined v-if="showSuccess"
                >Tack för att du har valt att köpa och använda våra tjänster! <br />Vi återkommer med mer information så
                snart som möjligt.</v-alert
              >
              <v-alert type="error" text outlined v-if="showError"
                >Oj, ett fel uppstod. Kontrollera fälten och försök igen. <br />Om det fortfarande blir fel så skicka
                ett vanligt mail till <a href="mailto:info@pretopia.se">info@pretopia.se</a></v-alert
              >
            </v-card-text>

            <v-card-actions class="pr-4 pb-3">
              <v-spacer></v-spacer>

              <v-btn v-if="!showSuccess" text :disabled="running" @click="cancel()"> Avbryt </v-btn>

              <v-btn
                v-if="!showSuccess"
                color="primary"
                class="black--text"
                @click="send()"
                :disabled="!isFormValid() || running"
                :loading="running"
              >
                Köp abonnemang
              </v-btn>

              <v-btn v-if="showSuccess" color="primary" class="black--text" @click="cancel()"> Stäng </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="mt-9">
        <v-col md="6" lg="6" offset-md="3" offset-lg="3">
          <!-- <v-col class="mb-10"> -->
          <span class="font-italic">* Gäller första året och endast på nya abonnemang som tecknas under mässan.</span>
          <br /><br />

          Paketen kan när som helst under året uppgraderas till ett större paket.<br />
          Det går även att köpa till utrymme för fler antal bilder eller nyhetsbrev, oavsett paket. Hör av er till oss
          hur många bilder ni vill att ert konto ska rymma eller hur många nyhetsbrev ni vill ha så återkommer vi med
          offert. <br />
          Vi erbjuder även total administration av kontot då vi byter ut, tar bort och lägger till bilder efter ert
          önskemål.<br />
          <span class="font-italic">Alla priser exkl moms.</span>

          <h3 class="mt-3 mb-4">Passar inte paketen dig? <br />Vi skräddarsyr ett paket efter dina önskemål!</h3>
          <p><router-link to="contactus">Kontakta oss så pratar vi igenom vad ni har för önskemål.</router-link></p>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { ContactUsService } from '../../services/contactus.service';

export default {
  props: {
    subscription: String,
  },

  data() {
    return {
      monthPrices: {
        basic: { discountPrice: '385', ordinariePrice: '550' },
        standard: { discountPrice: '749', ordinariePrice: '1 070' },
        premium: { discountPrice: '1 190', ordinariePrice: '1 700' },
        premium_plus: { discountPrice: '1 463', ordinariePrice: '2 090' },
        grande: { discountPrice: '1 764', ordinariePrice: '2 520' },
      },
      yearPrices: {
        basic: { discountPrice: '4 235', ordinariePrice: '6 050' },
        standard: { discountPrice: '8 239', ordinariePrice: '11 770' },
        premium: { discountPrice: '13 090', ordinariePrice: '18 700' },
        premium_plus: { discountPrice: '16 093', ordinariePrice: '22 990' },
        grande: { discountPrice: '19 404', ordinariePrice: '27 720' },
      },
      model: { company: { subscription: 'standard', subscriptionInterval: 'year' } },
      companyValid: false,
      showSuccess: false,
      showError: false,
      running: false,

      //rules
      requiredRules: [(v) => !!v || 'Obligatoriskt'],
    };
  },

  mounted() {
    if (this.subscription && this.monthPrices[this.subscription]) {
      this.model.company.subscription = this.subscription;
    }
    if (window.scrollTo) {
      window.scrollTo(0, 0);
    }
  },

  computed: {
    discountPriceMonth() {
      if (this.model.company.subscription) {
        return this.monthPrices[this.model.company.subscription].discountPrice;
      }
      return '--';
    },
    ordinariePriceMonth() {
      if (this.model.company.subscription) {
        return this.monthPrices[this.model.company.subscription].ordinariePrice;
      }
      return '--';
    },
    discountPriceYear() {
      if (this.model.company.subscription) {
        return this.yearPrices[this.model.company.subscription].discountPrice;
      }
      return '--';
    },
    ordinariePriceYear() {
      if (this.model.company.subscription) {
        return this.yearPrices[this.model.company.subscription].ordinariePrice;
      }
      return '--';
    },
  },

  methods: {
    send() {
      this.showError = false;
      this.showSuccess = false;
      this.running = true;

      new ContactUsService()
        .signupWithFormex(this.model.company)
        .then(() => {
          this.showSuccess = true;
          this.running = false;
          this.clearFields();
        })
        .catch(() => {
          this.showError = true;
          this.running = false;
        });
    },

    cancel() {
      this.$router.push({ path: '/formex' });
    },

    isFormValid() {
      return this.companyValid;
    },

    clearFields() {
      this.model = { company: { subscription: 'standard', subscriptionInterval: 'year' } };
    },
  },
};
</script>

<style scoped>
.price-badge {
  position: absolute;
  top: -16px;
  transform: translateX(50%);
  right: 50%;
  border: 1px solid #d1bf89 !important;
  background-color: #efe2b9 !important;
}
.text-shadow {
  text-shadow: 2px 2px 6px black;
}

.buy-button {
  width: 100%;
  font-size: 1em;
  height: 41px;
}
</style>
